import { useMemo } from "react";

import { buildProximityRings } from "helpers/proximityRings";
import { useDistanceLimits } from "hooks/useDistanceLimits";

const EMPTY_CENTERS = [];

/**
 * The proximity bands to draw around a map's address pins.
 *
 * @param {Object} args
 * @param {Array<{lat: number, lng: number}>} args.centers The map's address
 *   pins. Rings have nothing to anchor to without one.
 * @returns {{geoJson: Object, available: boolean}} `available` is what a surface
 *   offers its toggle on — false covers a map with no address pin and a tenant
 *   whose limits are unset or unreadable, both of which draw nothing.
 */
export function useProximityRings({ centers = EMPTY_CENTERS } = {}) {
  const { data: limits } = useDistanceLimits();

  const geoJson = useMemo(
    () => buildProximityRings({ centers, limits }),
    [centers, limits]
  );

  return { geoJson, available: geoJson.features.length > 0 };
}
